module.exports = __webpack_public_path__ + "static/img/22.aaada7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/22.png
// module id = oVaw
// module chunks = 0